/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {NgModule} from '@angular/core';
import {ActiveToolDirective} from './active-tool.directive';

@NgModule({
    declarations: [ ActiveToolDirective ],
    exports: [ ActiveToolDirective ],
})
export class ActiveToolModule {}
